import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { ReportViewerFileExportsComponent, SaveIndicatorComponent } from '@mode/report-viewer/shell';

export const DowngradedReportViewerShellModule = angular
  .module('downgraded-report-viewer-shell', [])
  .directive('modeReportViewerFileExports', downgradeComponent({ component: ReportViewerFileExportsComponent }))
  .directive('saveIndicator', downgradeComponent({ component: SaveIndicatorComponent })).name;
